<script setup>
defineProps({
    transaction: {
        type: Object
    }
});

function formatMoney(v) {
      let total = parseFloat(v);

      return total.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
}

function formatDate(d){
    
    let date = new Date(d);
    
    return date.toLocaleDateString('pt-BR', {timeZone: 'UTC'});

}

const emit = defineEmits(['edit', 'pay']);

const editTrasaction = (data) => {
    emit('edit', data);
}

const getContrastYIQ = (hexcolor) => {
    var r = parseInt(hexcolor.substring(1,3),16);
    var g = parseInt(hexcolor.substring(3,5),16);
    var b = parseInt(hexcolor.substring(5,7),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return (yiq >= 128) ? 'black' : 'white';
}

</script>

<template>
    <div class="col-12 border-bottom pt-2 pt-md-0 pb-2 pb-md-0">

        <div class="row align-items-center row-transactions"
            @click="editTrasaction(transaction)" 
            data-bs-toggle="modal" 
            data-bs-target="#detailsTransaction" 
            v-tooltip="{
                        content:'Ver detalhes',
                        distance: 15
                    }"
        >

            <div class="col-2 col-lg-1 ms-2 me-2 me-lg-0 text-center d-none d-lg-block" v-tooltip="{
                            content: transaction.category_name,
                            distance: 15
                        }">
                <div class="text-center shadow icon icon-shape align-self-center rounded-5" :style="'background-color: '+transaction.category_color">
                    <i :class="'fal ' + transaction.category_icon +' row-transactions-icons' " :style="'color:'+getContrastYIQ(transaction.category_color)"></i>
                </div>
            </div>

            
            <div class="col-12 col-sm-10">
                <div class="row align-items-center">
                    <div class="col-8 col-sm-6">
                        <h6 class="mb-0 text-md">{{ transaction.description }} {{ transaction.recurrence == 'Installments' ? '('+transaction.current_installment+'/'+transaction.end_installment+')' : '' }}</h6>
                        <div class="col-12 d-md-none">
                            <span class="badge badge-sm mt-2 fs-10 p-2" :style="'background-color: '+transaction.category_color + '; color:'+getContrastYIQ(transaction.category_color)">
                                <i class="fs-10 me-1" :class="'fal ' + transaction.category_icon +' row-transactions-icons' " :style="'color:'+getContrastYIQ(transaction.category_color)"></i>
                                {{ transaction.category_name }}
                            </span>
                            
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 text-lg-center d-none d-lg-block">
                        <h6 class="mb-0 text-md"></h6>
                    </div>
                    <div class="col-4 col-lg-3 text-end">
                        <p class="mb-1 text-sm">
                            {{ formatDate(transaction.date) }}
                        </p>
                        <span 
                            class="mb-0 text-md"
                            :class="transaction.type == 'despesa' ? 'text-danger' : transaction.type == 'receita' ? 'text-success' : ''"
                        >
                            {{ formatMoney(transaction.amount) }}
                        </span>
                    </div>
                </div>
            </div>            

        </div>

    </div>
</template>

<style>
    .row-transactions{
        min-height: 85px;
    }

    .hover-transaction{
        border-bottom: solid 1px #dee2e6;
    }

    .hover-transaction:hover{
        background-color: #f6f9fc;
        cursor: pointer;
    }

    .row-transactions-icons{
        font-size: 25px;
    }

    .row-transactions-icons-actions{
        font-size: 20px;
    }

    .color-paid {
        color: #2dce89 !important;
    }
</style>